import React from 'react'

import { ETaskStatus } from 'types/GlobalTask'
import { TTask } from 'redux/hooks/Tasks'
import { SxProps } from '@mui/material'

import { useTask } from 'redux/hooks/Tasks'
import { useTaskActions } from 'redux/actions/Tasks'
import { useTranslation } from 'language/translator'

import { ChipProps } from 'components_new/atoms/Chip'

import ChipSelect from 'components_new/molecules/ChipSelect'

interface TaskStatusChipProps {
  id?: string
  onChange?: (status: TTask['status']) => void
  size?: ChipProps['size']
  sx?: SxProps
  value?: TTask['status']
}

const TaskStatusChip = (props: TaskStatusChipProps) => {
  const { id, onChange, size, sx, value } = props
  const task = useTask(id ?? null)

  const { translateEnum } = useTranslation()
  const { tryUpdateTask } = useTaskActions()

  const handleUpdateStatus = (status: ETaskStatus) => {
    if (onChange) {
      onChange(status)

      return
    }

    if (id) {
      tryUpdateTask(id, { status })
    }
  }

  const status = value ?? task?.status ?? ETaskStatus.TODO

  return (
    <ChipSelect
      color={translateEnum('task_status', status).color}
      key="status"
      onChange={(value) => handleUpdateStatus(value.id as ETaskStatus)}
      options={[
        ETaskStatus.TODO,
        ETaskStatus.IN_PROGRESS,
        ETaskStatus.DONE
      ].map((status) => {
        return {
          color: translateEnum('task_status', status).color,
          icon: translateEnum('task_status', status).iconName,
          id: status,
          title: translateEnum('task_status', status).title
        }
      })}
      size={size}
      sx={sx}
      value={status}
    />
  )
}

export default TaskStatusChip
